// lazyload
import LazyLoad from "vanilla-lazyload";

import mainNav from "../modules/mainNav.js";

// // required select styling and checking
// import accordionsContainer from "../modules/accordionsContainer";

import { masonry } from "../modules/masonry";

import { wpcf7Validation } from "../modules/wpcf7Utilities.js";

import Search from "../modules/search";
import Modal from "../modules/modal";
// import gsapParallax from "../modules/gsapParallax";

// import { parallaxReveal } from "../modules/gsapReveals";

window.addEventListener("load", () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
  });

  new mainNav(".main-menu", ".main-nav", ".main-menu__toggle");

  // reveal init
  require("../modules/reveal");

  // accordionsContainer('.js-acc-main', '.js-acc-item', '.js-acc-toggle', '.js-acc-body', true);

  // swipers init
  require("../modules/swipers");

  // fslightbox gallery
  require("fslightbox");

  wpcf7Validation(true);

  masonry(".js-masonry");

  // sec3Parallax('.gsap-parallax');
  // parallaxReveal('.js-gsap-parralax-reveal');

  require("../modules/lightboxWPGallery");

  new Search();
  new Modal({
    openButton: ".cars-modal",
    closeButton: ".js-modal-close",
    autoOpen: false,
    openClass: "is-active",
  });
});
